<div class="app">
    <div
        class="app__inner app_full-size"
        [ngClass]="{
            'app__inner_desktop-min-width': isDesktopMinWidth(),
            'app-account-mobile': isAccountMobileMarkup()
        }"
    >
        @if (!isSideMenuHidden()) {
            <app-menu></app-menu>
        }
        <app-backdrop></app-backdrop>
        <div class="app__main" [ngClass]="{'app__main_pages-width': !isSideMenuHidden()}">
            @if (!isHeaderHidden()) {
                <app-header></app-header>
            }
            <div class="app__content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
